"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = throttle;
function cov_rcsx3lcqz() {
  var path = "/__w/code/code/js/packages/bricks/src/helpers/throttle.ts";
  var hash = "883b0d18b2dc0c43ebb7959b335b6936d10b44c0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/helpers/throttle.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 13
        },
        end: {
          line: 5,
          column: 18
        }
      },
      "1": {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 10,
          column: 3
        }
      },
      "2": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 9
        }
      },
      "3": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 17
        }
      },
      "4": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 70
        }
      },
      "5": {
        start: {
          line: 12,
          column: 16
        },
        end: {
          line: 12,
          column: 68
        }
      }
    },
    fnMap: {
      "0": {
        name: "throttle",
        decl: {
          start: {
            line: 4,
            column: 24
          },
          end: {
            line: 4,
            column: 32
          }
        },
        loc: {
          start: {
            line: 4,
            column: 61
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 7,
            column: 17
          }
        },
        loc: {
          start: {
            line: 7,
            column: 22
          },
          end: {
            line: 10,
            column: 3
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 12,
            column: 9
          },
          end: {
            line: 12,
            column: 10
          }
        },
        loc: {
          start: {
            line: 12,
            column: 16
          },
          end: {
            line: 12,
            column: 68
          }
        },
        line: 12
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 23
          },
          end: {
            line: 12,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 12,
            column: 23
          },
          end: {
            line: 12,
            column: 27
          }
        }, {
          start: {
            line: 12,
            column: 31
          },
          end: {
            line: 12,
            column: 68
          }
        }],
        line: 12
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "883b0d18b2dc0c43ebb7959b335b6936d10b44c0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_rcsx3lcqz = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_rcsx3lcqz();
// throttle fn that uses requestAnimationFrame instead of setTimeout
// lodash throttle uses requestAnimationFrame in later versions that we aren't on

function throttle(fn) {
  cov_rcsx3lcqz().f[0]++;
  var tick = (cov_rcsx3lcqz().s[0]++, false);
  cov_rcsx3lcqz().s[1]++;
  var runCb = function runCb() {
    cov_rcsx3lcqz().f[1]++;
    cov_rcsx3lcqz().s[2]++;
    fn();
    cov_rcsx3lcqz().s[3]++;
    tick = false;
  };
  cov_rcsx3lcqz().s[4]++;
  return function () {
    cov_rcsx3lcqz().f[2]++;
    cov_rcsx3lcqz().s[5]++;
    return tick = (cov_rcsx3lcqz().b[0][0]++, tick) || (cov_rcsx3lcqz().b[0][1]++, !!window.requestAnimationFrame(runCb));
  };
}